export const queryString = (query = ''): Record<string, string> => {
  const queryParams: Record<string, string> = {};
  if (!query.length) return queryParams;
  const searchParams = new URLSearchParams(query).entries();
  for (const [key, val] of searchParams) {
    queryParams[key] = val;
  }
  return queryParams;
};
